<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório PTs
            <ModalPT
              @filtrar="getRelatorioGeralPT"
              :loadingValue="loadingValue"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :exportName="'Relatorio_Geral_PTs'"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'relatoriogeral_pt'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";

import ModalPT from "../components/ModalPT.vue";
import Flexmonster from "../components/Flexmonster.vue";
import { useRoute } from "vue-router";

export default {
  components: { Flexmonster, ModalPT },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref([]);
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getRelatorioGeralPT = async (filtrosFormatados, filtrosOriginais) => {
      try {
        let filtrosObject = {
          de: filtrosOriginais.dataInicial,
          ate: filtrosOriginais.dataFinal,
          unidade: filtrosOriginais.unidade?.label,
          modelo: filtrosOriginais.modeloId || "",
          ptId: filtrosOriginais.ptId || "",
          emissor: filtrosOriginais.emissor || "",
          participante: filtrosOriginais.participante || "",
          local: filtrosOriginais.local || "",
          status:
            filtrosOriginais.status
              ?.map((s) => {
                const statusMap = {
                  aberto: "Em aberto",
                  aguardando_assinaturas: "Em assinatura",
                  iniciado: "Iniciado",
                  encerrado: "Encerrado",
                  cancelado: "Cancelado",
                  finalizado: "Finalizado",
                };
                return statusMap[s] || s;
              })
              .join(", ") || "Todos",
          atividade: filtrosOriginais.atividade || "",
        };

        loadingValue.value = true;
        const response = await store.dispatch(
          "rel/getRelatorioGeralPT",
          filtrosFormatados
        );

        link.value = response.data.resultado.dados;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
        loadingValue.value = false;
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.resultado.dados;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getRelatorioGeralPT,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      id,
      getRelatorioSalvo,
      filtros,
      showTotals,
      url,
      urlEp,
      gerarCsv,
      dados,
      formats,
      loadingStop,
      verificarUrl,
      showGrandTotals,
    };
  },
};
</script>
